import { createAction } from 'redux-actions';
import { RefundDocumentsState } from '../types';

export const SET_DOCUMENTS = 'REFUND/SET_DOCUMENTS';
export const SET_UPLOADED_FILES = 'REFUND/SET_UPLOADED_FILES';
export const DELETE_UPLOADED_FILE = 'REFUND/DELETE_UPLOADED_FILE';

export interface SetUploadedFilesPayload {
	passengerId: string;
	files: File[] | null;
}

export interface DeleteUploadedFilePayload {
	passengerId: string;
	fileId: string;
}

export const setDocuments = createAction<RefundDocumentsState>(SET_DOCUMENTS);

export const setUploadedFiles = createAction<SetUploadedFilesPayload>(SET_UPLOADED_FILES);

export const deleteUploadedFile = createAction<DeleteUploadedFilePayload>(DELETE_UPLOADED_FILE);

export type SetDocumentsAction = ReturnType<typeof setDocuments>;
export type SetUploadedFilesAction = ReturnType<typeof setUploadedFiles>;
export type DeleteUploadedFileAction = ReturnType<typeof deleteUploadedFile>;

export type ActionDocumentsTypes = SetDocumentsAction | SetUploadedFilesAction | DeleteUploadedFileAction;
